import React from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Tooltip } from '@mui/material';


export default function HelpTooltip(props) {
    const {text} = props


  
    return (
      <span
        style={{margin:'5px', 
        padding:'0px', 
        position:'relative', 
        top:'2px'}}
      >
        <Tooltip title={text} 
          placement='top' 
          arrow>
            <HelpOutlineIcon fontSize='small' />
        </Tooltip>
      </span>
    );
}